<template>
    <div v-show="isShow" class="ai-seek" @click="jumpAIPage">
        <div class="ai-seek-container" v-if="!isOpen">
            <img class="ai-seek-icon" src="../assets/imgs/ai-front.png">
            <div class="ai-seek-btn">
                <div class="ai-seek-text">CoMi一搜</div>
            </div>
        </div>
    </div>
</template>
<script>
import comiMixin from "@/mixins/comiMixin.js";

export default {
    name: "AISeek",
    props: {
    },
    mixins: [comiMixin],
    data() {
        return {
            visible: false,
            iframeUrl: ''
        }
    },
    computed: {
        isShow(){
            const hidePages = ['home']
            return !hidePages.includes(this.$route.name)
        }
    },
    created() {
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
.ai-seek {
    &-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        font-size: 12px;
        background: #ffffff;
        color: #333;
        box-shadow: 0px 2px 24px 0px rgba(0,0,0,0.10); 
        cursor: pointer;

        &:hover{
            color: #007AFF;
        }
    }


    &-icon{
        width: 28px;
    }

    &-content{
        overflow-x: auto;
        overflow-y: hidden;
        height: 78vh;
    }

    &-btn {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

@media screen and (max-width: 824px) {
    .ai-seek{
        display: none;
    }
}
</style>